export default {
    formatCurrency: function(value, decimals = 0, currency = 'USD') {
        let locale = 'en-US'
        let options = { style: 'currency', currency: currency, maximumFractionDigits: decimals}

        return new Intl.NumberFormat(locale, options).format(value / 100)
    }
}